import tokenService from './tokenService';

const BASE_URL = '/api/users/';

function signup(user) {
  //console.log(user, '<-user in signup');
  return fetch(BASE_URL + 'signup', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(user)
  })
    .then((res) => {
      if (res.ok) return res.json();
      console.log(res);
      //throw new Error('Email already taken!');
    })
    .then(({ token }) => tokenService.setToken(token));
}

function getUser() {
  return tokenService.getUserFromToken();
}

function logout() {
  tokenService.removeToken();
}

function login(creds) {
  return fetch(BASE_URL + 'login', {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(creds)
  })
    .then((res) => {
      // Valid login if we have a status of 2xx (res.ok)
      if (res.ok) return res.json();
      console.log(res);
      return res.json().then((response) => {
        console.log(response);
        throw new Error(response.err);
      });
    })
    .then(({ token }) => tokenService.setToken(token));
}

function update(updateData) {
  console.log(updateData, '<-updateData');
  return fetch(BASE_URL + 'update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updateData)
  }).then((res) => {
    console.log(res, '<-res');
    if (res.ok) return res.json();
    throw new Error('Update failed!');
  });
}

export default {
  signup,
  logout,
  login,
  getUser,
  update
};
